<template>
<v-dialog v-model="mostrar" scrollable persistent max-width="70vw">
		
    <v-card max-height="600px">
		<v-toolbar flat color="primary"></v-toolbar>
		<v-divider></v-divider>
		
		<v-card-text>
		    <v-row v-if="cadastrandoNovoItem" class="itensForm">
				<v-col cols="2">
					<v-select :items="this.unidades" v-model="itemEvento.unidade" label="Unidade" outlined></v-select>
				</v-col>
				<v-col cols="8">
					<v-text-field label="Nome" v-model="itemEvento.nome" outlined></v-text-field>
				</v-col>
				<v-col cols="2">
					<v-text-field label="Quantidade" type="number" value="1" min="1" v-model="itemEvento.quantidade" outlined></v-text-field>
				</v-col>
            </v-row>
            <div v-else>
                <v-data-table dense fixed-header class="table-item" :items="itens" :headers="headers" :items-per-page="5">
                    <template v-slot:item.action="{ item }">
                        <v-btn text color="primary" @click="editarItem(item)">
                            <i class="fa fa-pencil"></i>
                        </v-btn>
                        <v-btn text color="primary" @click="excluirItem(item)">
                            <i class="fa fa-trash"></i>
                        </v-btn>
                    </template>
                </v-data-table>
                <v-dialog v-model="dialogExcluir" max-width="500px">
                    <v-card>
                        <v-card-title>
                            <h2>Exclusão de item para doação</h2>
                        </v-card-title>
                        <v-card-text class="mt-4">
                            <p>Você está realizando a exclusão do item abaixo:</p>
                            <p>Código: {{itemEvento.id_item}}<br/>Nome: {{itemEvento.nome}}</p>
                            <p v-if="itemEvento.quantidade != itemEvento.qtd_pendente">Esse item já tem {{itemEvento.quantidade - itemEvento.qtd_pendente}} doado(s).</p>
                            <h3>Deseja confirmar a exclusão?<br />Essa operação não poderá ser desfeita!</h3>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn text color="primary" @click="confirmarExcluir()">Confirmar</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="dialogExcluir = false">Cancelar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn text color="primary" v-if="!cadastrandoNovoItem" class="modal-default-v-btn" @click="novoItem">Novo item</v-btn>
			<v-btn text color="primary" v-else class="modal-default-button" @click="salvarItem">Salvar item</v-btn>
			<v-btn text color="primary" v-if="cadastrandoNovoItem" class="modal-default-button" @click="CancelarEdicaoItem">Cancelar</v-btn>
			<v-btn text color="primary" class="modal-default-button" @click="fechar()">Fechar</v-btn>
		</v-card-actions>
	</v-card>
</v-dialog>
</template>
<script>

import {baseApiUrl, showError, showSuccess} from '@/config/global'
import axios from 'axios'
import { mapState } from 'vuex'
import Br from '@/config/barramento'

export default{
    props:['evento', 'mostrar'],
    computed:{
			...mapState(['user']),
    },
    data(){
        return{
            cadastrandoNovoItem: false,
            itemEvento: {},
            dialogExcluir: false,
            headers: [
					{text: 'Código', value: 'id_item', align: 'center', divider: true},
					{text: 'Nome', value: 'nome', align: 'center', divider: true},
					{text: 'Quantidade', value: 'quantidade', align: 'center', divider: true},
					{text: 'Qtd pendente', value: 'qtd_pendente', align: 'center', divider: true},
					{text: 'Und', value: 'nome_unidade', align: 'center', divider: true},
					{text: 'Ações', value: 'action', align: 'center', divider: true}
                ],
            itens: [],
            unidades: {}
        }
    },

    methods:{


        salvarItem(){

				if(!this.itemEvento.quantidade > 0){
					showError("Quantidade precisa ser maior que 0")
					return false
				}
				if(!this.itemEvento.id_item){
					
					if(this.itemEvento.unidade && this.itemEvento.nome && this.itemEvento.quantidade > 0){
						const url = `${baseApiUrl}/itensEventos/inserir.php`
						this.itemEvento.id_iniciado = this.user.iniciado
						this.itemEvento.id_evento = this.evento.id
							
						axios.post(url, this.itemEvento)
						.then(res => {
							
							if(res.data.codigo == '01'){
								
								showSuccess(res.data.mensagem)
								this.itemEvento.id_item = res.data.id_item
								this.itemEvento.qtd_pendente = this.itemEvento.quantidade

								this.unidades.forEach((v, i, a) => {
									if(v.value == this.itemEvento.unidade){
										this.itemEvento.nome_unidade = v.text
									}
								})
								this.itens.push(this.itemEvento)
								this.cadastrandoNovoItem = false	
								
							}else{
								
								showError(res.data.mensagem)
							}
						})
					}else{
						showError("Todos os campos devem ser informados")
					}
					
				}else{

					const url = `${baseApiUrl}/itensEventos/update.php`
					this.itemEvento.id_iniciado = this.user.iniciado

					axios.post(url, this.itemEvento)
					.then(res => {
						
						if(res.data.codigo == '01'){
							
							let idx = this.itens.findIndex((v, i, a) => {
                                
                                return v.id_item == this.itemEvento.id_item
                            })
							
							this.itens[idx].quantidade = this.itemEvento.quantidade
                            
                            this.itemEvento.qtd_doacao >= 0 ? this.itens[idx].qtd_pendente = this.itemEvento.quantidade - this.itemEvento.qtd_doacao : this.itens[idx].qtd_pendente = this.itemEvento.quantidade
                            
                          

							showSuccess(res.data.mensagem)
							this.cadastrandoNovoItem = false	
							
						}else{
							
							showError(res.data.mensagem)
						}
					})

					
				}
				
			},

        buscaItens(){

				const url = `${baseApiUrl}/itensEventos/read.php?id_evento=${this.evento.id}`
				axios.get(url)
				.then(res => {
					
					if(res.data.codigo == '01'){
					
						this.itens = res.data.dados.itens
						this.unidades = res.data.dados.unidades.map(r => {
							return {
								value: r.id, text: r.nome
							}
						})

					}else if(res.data.codigo == '02'){
						this.unidades = res.data.dados.unidades.map(r => {
							return {
								value: r.id, text: r.nome
							}
						})						
					}else{
						showError(res.data.mensagem)
					}
				})
            },
            
            fechar(){
                this.cadastrandoNovoItem = false
                this.itemEvento = {}
                Br.setFecharDoacoes()
            },

            novoItem(){
                this.itemEvento = {}
                this.cadastrandoNovoItem = true
            },

            editarItem(item){
				this.itemEvento = item
				this.cadastrandoNovoItem = true
            },
            
            excluirItem(item){

                this.dialogExcluir = true
				this.itemEvento = item
            },
            
            CancelarEdicaoItem(){
                this.cadastrandoNovoItem = false
            },

            confirmarExcluir(){
				const url = `${baseApiUrl}/itensEventos/delete.php`
				
				axios.post(url, {id: this.itemEvento.id_item})
				.then(res => {
					
					if(res.data.codigo == '01'){
						
						showSuccess(res.data.mensagem)

						let idx = this.itens.findIndex((v, i, a) => {
                                return v.id_item == this.itemEvento.id_item
                            })
						
						this.itens.splice(idx, 1)
						this.dialogExcluir = false

						
					}else{
						
						showError(res.data.mensagem)
						this.dialogExcluir = false
					}
				})
		
			},

    },
	
	watch:{
		mostrar(val){
			if(val){
				this.buscaItens()
			}
		}
	}
}
</script>
<style scoped></style>